import { Component, Input } from '@angular/core';
import { ActionSheetController } from 'ionic-angular';

// Providers
import { FilesService } from '../../providers/files/files-service';
import { HelperService } from '../../providers/helpers/helper-service';

@Component({
  selector: 'file-component',
  templateUrl: 'file.component.html'
})

export class FileComponent {
  @Input() files: any;
  @Input() title: string;
  @Input() instructorId: number;

  filePurpose: string = '';

  constructor(
    public actionSheetCtrl: ActionSheetController,
    public filesService: FilesService,
    public helperService: HelperService
  ) {
    console.log(this.files);
  }

  deleteFile( file )
  {
    this.filesService.deleteFile( file.file_primary_id )
      .subscribe( data => {
        // Remove file from this.files.
        for ( let i in this.files )
        {
          if ( this.files[i].file_id === file.file_id )
          {
            this.files.splice(i, 1);
          }
        }
      });
  }

  instructorDocumentUploaded( fileObj )
  {
    let newFileObj:any = this.helperService.makeFileObject( fileObj );
    newFileObj.file_purpose = this.filePurpose;
    newFileObj.instructor_id = this.instructorId;
    this.filesService.saveFileEntry( newFileObj )
        .subscribe( data => {
          this.files.push( data );
        }); 
  }

  presentDeleteFileActionSheet( file )
  {
    let actionSheet = this.actionSheetCtrl.create({
      title: 'Are you sure you want to delete this file?',
      buttons: [
        {
          text: 'Delete file',
          role: 'destructive',
          handler: () => {
            this.deleteFile( file );
          }
        },
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {}
        }
      ]
    });

    actionSheet.present();
  }

  ngOnInit() {
    const that = this;
    setTimeout( function() {
      console.log(that.files);
    }, 1000);
  }
}


// WEBPACK FOOTER //
// ./src/components/file/file.component.ts